import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import axios from 'axios';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private httpClient: HttpClient, private cookieService: CookieService, private router: Router) {
  }

  stripquotes(a) {
    if (a.charAt(0) === '"' && a.charAt(a.length-1) === '"') {
        return a.substr(1, a.length-2);
    }
    return a;
  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

      console.log('Entering canActivate()');

      let token;
      let userInfo;
      let reqState = null;
      let reqNonce = null;

      const cookieState = this.cookieService.get('NextGenState');   
     
      // if there is a mars incident number in the params, save it in local storage. We do this b/c if the user goes to fsapps, we lose the query params
      if (route.queryParams.mars) {
        console.log('Setting MARSNumber');
        window.sessionStorage.setItem('marsNumber', route.queryParams.mars.toString());
      }
      

    // check session storage for a logged in user
    console.log('Checking for logged in user');
    if (window.sessionStorage.getItem('userInfo')) {
      console.log('HAVE logged in user');
      let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
      if (userInfo.status && userInfo.role !== 'unregistered') {
        console.log('Logged In User OK');
        // if the user is logged in and registered then we check if there is a mars number in the local storage and redirect to the mars incident page
        const marsNumber = window.sessionStorage.getItem('marsNumber')
        if (marsNumber) {
          console.log('Fetching MARSNumber');
          window.location.href = environment.HOME_URL + '/#/mars/incident/' + marsNumber;
          window.sessionStorage.removeItem('marsNumber');
          return true;
        } else {
          return true;
        }
      }
    }

    // check session storage for a token
    if (window.sessionStorage.getItem('token')) {
      console.log('We have a Token in session storage');
      token = window.sessionStorage.getItem('token');
    }
    // check query params for a token
    // set / refresh the token value in session storage
    if (route.queryParams.t) {
      console.log('We have a Token in query string');      
      token = route.queryParams.t;
      window.sessionStorage.setItem('token', token);
    }

    // check query params for id from FSApps NxtGen and save it
    let fsAppsId = route.queryParams.id;
    if (fsAppsId) {
      console.log(`FOUND id param: [${fsAppsId}]`);
      window.sessionStorage.setItem('fsAppsId', fsAppsId);
    } else {
      console.log('NOT FOUND!! id param');
    }

    if (!token && environment.USE_FSAPPS_NEXT_GEN == 'Y') {

      console.log('(1a) NO Token / USE_FSAPPS_NEXT_GEN == Y');

      let loggedIn = window.sessionStorage.getItem("loggedIn");

      if (loggedIn != 'Y' && !route.queryParams.t) {

        console.log('(1b) NOT loggedIn && NO t Query Param - calling getauthrequest');
        console.log('sessionStorage auth.guard', window.sessionStorage);
        console.log('cookies auth.guard', this.cookieService.getAll());

        // fetch auth url from api
        this.httpClient.get(environment.AUTH_URL + '/fsappsnextgen/getauthrequest', {responseType: 'text'})
        .subscribe(
          (response) => {

            console.log('(1c) - Response from getauthrequest: ' + response)

            let authUrl = this.stripquotes(response);

            console.log('authUrl = ' + authUrl);

            // take out the state and save it 
            const urlParams = new URLSearchParams(authUrl);
            const urlState = urlParams.get('state');

            this.cookieService.set('NextGenState', urlState);

            console.log('(1d) About to redirect to Auth URL...');

            window.open(authUrl, '_self', 'noopener');          
        
          },
          (error) => {
            console.log('error: ' + error);
            if (environment.extraDebugging && !environment.production) {
              alert('error: ' + error);
            }
          }
        );

        return;
      }
    } 

    if (token) {

      //if we're using FSApps NextGen, get the state and check it from the 
      if (environment.USE_FSAPPS_NEXT_GEN == 'Y') {
        let urlState = route.queryParams.state;

        if (urlState) {
          if (urlState === cookieState) {
            console.log('CALLBACK - retrieved state from URL MATCHES COOKIE [OK]');                    
          } else {
            console.log('CALLBACK - retrieved state from URL : [' + urlState + '] - COOKIE: [' + cookieState + ']');          
            alert('LOGIN Error: Invalid State');
            console.log('INVALID STATE - Redirect to LOGIN_PORTAL');
            window.location.href = environment.LOGIN_PORTAL;
            return false
          } 
        }
        else {
          console.log('No State in URL... skipping');                                
        }
      }

      console.log('calling /isRegistered');
      axios
        .get(environment.AUTH_URL + '/isRegistered', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          // if the user is registered
          if (response.data) {

            console.log('calling /userInfo');

            axios
              .get(environment.AUTH_URL + '/userInfo', {
                headers: { Authorization: 'Bearer ' + token }
              })
              .then((userResponse) => {
                let userInfo = userResponse.data;

                console.log('calling /base/dropdown/main');
                axios
                  .get(environment.API_URL + '/base/dropdown/main', {
                    headers: { Authorization: 'Bearer ' + token }
                  })
                  .then((response) => {

                    if (userInfo.baseId > 0) {
                      let bases = response.data.filter(
                        (base) =>
                          base.baseId.toString() === userInfo.baseId.toString()
                      );
                      let userBase = bases[0];
  
                      userInfo.baseName = userBase.text
                      userInfo.basecode = userBase.baseCode;
                      userInfo.baseCode = userBase.baseCode;
                      window.sessionStorage.setItem(
                        'userInfo',
                        JSON.stringify(userInfo)
                      );
                    }

                    if (userInfo.role === 'unregistered') {
                      window.location.href =
                        environment.HOME_URL + '/#/register';
                        return true;
                    }                      

                    // if user is only 'registered', let them know their role must be set
                    if (userInfo.role === 'registered') {
                      window.location.href = environment.HOME_URL + '/#/registered';
                      return true;
                    }

                    window.sessionStorage.setItem("loggedIn", "Y");
                    // if there is a mars incident number in the local storage, redirect to the mars incident page
                    const marsNumber = window.sessionStorage.getItem('marsNumber')
                    if (marsNumber) {
                      window.location.href = environment.HOME_URL + '/#/mars/incident/' + marsNumber;
                      window.sessionStorage.removeItem('marsNumber');
                      return true;
                    } else {
                      window.location.href =
                        environment.HOME_URL + '/#/dashboard';
                      return true;
                    }


                  })
                  .catch((error) => {
                    console.log('error getting base info');
                    console.dir(error);
                  });
              })
              .catch((error) => {
                console.log('error getting user info');
                console.log(error);
              });
          } else {
            // if the user is not registered redirect to /register
            window.location.href = environment.HOME_URL + '/#/register';
            return false;
          }
        })
        .catch((error) => {
          console.log('error getting registration info for user');
          console.dir(error);
          window.location.href = environment.LOGIN_PORTAL;
          return false
        });
    } else {
      // if there is no token redirect to login
      console.log('NO TOKEN - Redirect to LOGIN_PORTAL');
      window.location.href = environment.LOGIN_PORTAL;
      return false;
    }
  }
}